<template>
  <section v-if="product" :aria-label="$t.reviews" class="b-t b-grey-70 p-6 lg:py-20 <lg:-mx-4">
    <base-lazy-load>
      <div class="text-center">
        <h2 class="body-3">
          {{ reviewsCount > 0 ? $t.reviews : $t.reviewsNone }}
        </h2>
        <div v-if="ratio > recommendationRateThreshold" class="mt-2 space-y-2">
          <p v-if="rollup.averageRating">
            <span class="title-1">{{ rollup.averageRating }}</span>
            <span class="title-2"> / 5</span>
          </p>
          <vf-rating v-if="rollup.averageRating" class="mx-a c-brand-4 lg:hidden" :value="rollup.averageRating" />
          <vf-rating
            v-if="rollup.averageRating"
            class="mx-a c-brand-4 <lg:hidden"
            size="md"
            :value="rollup.averageRating"
          />
        </div>
        <div v-else-if="!reviewsCount" class="mt-2 space-y-2">
          <p aria-hidden="true">
            <span class="title-1">-</span>
            <span class="title-2"> / -</span>
          </p>
          <p class="subtitle-5">
            {{ $t.reviewsBeTheFirst }}
          </p>
        </div>
        <div class="mt-4 lg:mt-6" :class="{ 'inline-grid cols-2 gap-2 lg:gap-4': reviewsCount }">
          <vf-button v-if="reviewsCount" @click="openReviews">
            {{ replaceAll($pluralize($t.numberOfReviews, reviewsCount), { reviewsCount }) }}
          </vf-button>
          <vf-button
            variant="secondary"
            @click="openWriteReview"
          >
            {{ $t.writeAReview }}
          </vf-button>
        </div>
        <panel-reviews size="lg" />
        <panel-review-write />
      </div>
    </base-lazy-load>
  </section>
</template>

<script setup lang="ts">
import type { ProductReviewsRollup } from '#root/api/clients/product/data-contracts'

const { $gtm } = useNuxtApp()
const { recommendationRateThreshold } = useAppConfig().pages.pdp.reviews
const { product, reviewsData } = usePdp()

const rollup = computed(() => reviewsData.value?.rollup || {} as ProductReviewsRollup)
const ratio = computed(() => Math.round((rollup.value.recommendedRatio || 0) * 100))
const reviewsCount = computed(() => rollup.value.reviewCount || 0)

const PanelReviewWrite = createPanel('review-write')
const PanelReviews = createPanel('reviews')

const openReviews = () => {
  $gtm.push('pdpPage.onViewReviews')
  PanelReviews.open()
}

const openWriteReview = () => {
  $gtm.push('pdpPage.onWriteReview')
  PanelReviewWrite.open({
    pageId: reviewsData.value?.reviewsPageId || reviewsData?.value?.pageId,
    productId: product.value?.id!
  })
}
</script>
